package net.frozenbit.games.soundgame.ui

import androidx.compose.animation.AnimatedContentScope
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.SharedTransitionScope
import androidx.compose.animation.core.EaseIn
import androidx.compose.animation.core.MutableTransitionState
import androidx.compose.animation.core.tween
import androidx.compose.animation.scaleIn
import androidx.compose.foundation.layout.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import net.frozenbit.games.soundgame.components.*
import net.frozenbit.games.soundgame.theme.Dimensions
import net.frozenbit.games.soundgame.utils.Countdown
import net.frozenbit.games.soundgame.viewmodels.presentation.PlayerTagData
import net.frozenbit.games.soundgame.viewmodels.presentation.SoundCreation

context(screenTransitions: AnimatedContentScope)
@Composable
fun SharedTransitionScope.HostVotingScreen(
    joinCode: String,
    jury: PlayerTagData,
    creations: List<SoundCreation>,
    countdown: Countdown.Tick?,
    promptText: String,
) {
    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(Dimensions.Host.bigInnerPadding, Alignment.Top),
        ) {
            Prompt(
                promptText,
                modifier = Modifier.sharedElement(
                    rememberSharedContentState(key = "prompt"),
                    screenTransitions,
                )
            )
            AnimatedVisibility(
                visibleState = remember { MutableTransitionState(false).apply { targetState = true } },
            ) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceEvenly,
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 16.dp)
                ) {
                    creations.forEachIndexed { index, option ->
                        SoundCreationBox(
                            option,
                            modifier = Modifier
                                .weight(1f, fill = false)
                                .sharedElement(
                                    rememberSharedContentState(key = "creation_$index"),
                                    screenTransitions,
                                )
                                .animateEnterExit(
                                    enter = scaleIn(
                                        tween(durationMillis = 300, delayMillis = index * 50, easing = EaseIn)
                                    )
                                )
                        )
                    }
                }
            }
        }
        QuarterArc(
            modifier = Modifier
                .align(Alignment.BottomStart)
        )
        Column(
            verticalArrangement = Arrangement.spacedBy(8.dp, Alignment.Top),
            modifier = Modifier
                .align(Alignment.BottomStart)
                .padding(16.dp)
        ) {
            countdown?.let {
                CountdownTimer(
                    it,
                    modifier = Modifier
                        .align(Alignment.CenterHorizontally)
                )
            }
            PlayerTag(jury)
        }
        JoinCode(
            joinCode,
            modifier = Modifier
                .align(Alignment.BottomEnd)
                .padding(16.dp)
        )
    }
}

